import { type Config, config as usConfig } from './en';

export const config: Config = {
  ...usConfig,
  seo: {
    ...usConfig.seo,
    uniqueCanonicalUrl: 'https://www.lemonade.com/',
  },
  layout: {
    ...usConfig.layout,
    floatingCheckOurPricesInMobile: true,
    alignLogoOnMobile: 'center',
  },
};
